import type { ShapeManagerRef } from '@/lib/shapes/types/shape-manager-ref'
import type { UndoAction } from '@/lib/history/types/undo-action'
import type { HistoryDirection } from '@/lib/history/types/history-direction'
import type { ChromeSnapshot } from '../types/chrome-snapshot'

export function selectionAfterHistoryStep(
  prev: string[],
  validIds: Set<string>,
  fallbackTouchedIds: string[]
): string[] {
  const preserved = prev.filter((id) => validIds.has(id))

  if (preserved.length > 0) return preserved

  return fallbackTouchedIds.filter((id) => validIds.has(id))
}

export function selectShapesForHistoryReplay(mgr: ShapeManagerRef, ids: string[]): void {
  mgr.selectShapesForHistory(ids)
}

export function getSelectionChromeForDirection(
  action: UndoAction,
  direction: HistoryDirection
): ChromeSnapshot | null {
  if (action.type === 'batchUpdate' || action.type === 'selection') {
    return direction === 'undo'
      ? (action.multiSelectChromeBefore ?? null)
      : (action.multiSelectChromeAfter ?? null)
  }

  return null
}
